import { createColumnHelper } from '@tanstack/react-table';
import { LocalizedText } from '@mews/framework';
import { omit } from '@mews/std';
import { TextKey } from '@mews-commander/enums';
import { Checkbox } from '@optimus-web/core';
import { EnterpriseProfilePrivilegesEnumNames } from '@mews-commander/legacy-data-structures';
import { PrivilegeName } from '../PrivilegeName';

export interface PrivilegesTableColumns {
    value: EnterpriseProfilePrivilegesEnumNames;
}

const columnHelper = createColumnHelper<PrivilegesTableColumns>();

export const useColumns = ({
    rowSelection,
    handleRowSelectionChange,
}: {
    rowSelection: Record<string, boolean>;
    handleRowSelectionChange: (value: Record<string, boolean>) => void;
}) => [
    columnHelper.display({
        id: 'selector',
        header: undefined,
        cell: (props) => {
            const privilege = String(props.row.getValue('value'));

            return (
                <Checkbox
                    checked={rowSelection[privilege]}
                    onChange={(_, checked) =>
                        handleRowSelectionChange(
                            checked ? Object.assign(rowSelection, { [privilege]: true }) : omit(privilege, rowSelection)
                        )
                    }
                />
            );
        },
    }),
    columnHelper.accessor('value', {
        header: () => <LocalizedText textKey={TextKey.Privileges} />,
        cell: (props) => <PrivilegeName privilege={props.getValue()} />,
        enableSorting: true,
    }),
];
